import React, {
  Suspense,
  type LazyExoticComponent,
  type ReactElement,
  type ComponentProps,
} from 'react';

import Loader from '@components-legacy/Loader';

/**
 * Returns a component wrapped in a loader
 */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ // Couldn't get around the any
const asyncComponent = <Type extends LazyExoticComponent<any>>(
  /** Lazy loaded component */
  Component: Type,
  /** Display name for component. Useful for React Devtools */
  displayName = 'Unknown',
  /** Component to display while loading */
  fallback: ReactElement = <Loader />
) => {
  const AsyncComponent = (props: ComponentProps<Type>) => (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );

  if (displayName) {
    AsyncComponent.displayName = `async(${displayName})`;
  }

  return AsyncComponent;
};

export default asyncComponent;
